"use strict";
var ko = require("knockout");
var CommentLoadUtil = (function () {
    function CommentLoadUtil() {
    }
    /** Флаг загрузки комментариев */
    CommentLoadUtil.loaded = ko.observable(false);
    return CommentLoadUtil;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CommentLoadUtil;
//# sourceMappingURL=commentLoadUtil.js.map